import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset, ITree, ISearchSort
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"


import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";


const vWB_AffSet_Fields: { [id: string]: ISearchProviderField } = {
    WB_AFFINITYSET_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'WB Id', columnResourceName: 'colId', alignment: HorizAlignment.Center},
        domainOptions: {}
    },
    AFFINITYSET_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Id', columnResourceName: 'colPGId', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50},
    },
    AFFINITYSET_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 256}
    },
    CUSTOMER_LEVEL_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Customer Level',
            columnResourceName: 'colSubTypeID',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 50}
    },
    PRODUCT_LEVEL_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Product Level', columnResourceName: 'colTypeID', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    CANNIBALIZATION_TYPE_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Cannibalization Type Name',
            columnResourceName: 'colCannName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 50}
    },
    WB_MODEL_CANNIBALIZATIONM_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Cannibalization Type Id',
            columnResourceName: 'colCannWBId',
            alignment: HorizAlignment.Left,
        },
        domainOptions: {}
    },
}

const vWB_AffSet_KeyFields =
    {
        id: 'WB_AFFINITYSET_ID',
        id_ui: 'AFFINITYSET_ID',
        name: 'AFFINITYSET_NAME'
    }


class AffinitySetSearchByCannibalizationTypeSearchProvider
    implements ISearchProvider {

    aCannibalizationTypeId = 0

    constructor(WB_MODEL_CANNIBALIZATIONM_ID: number) {
        this.aCannibalizationTypeId = WB_MODEL_CANNIBALIZATIONM_ID
    }

    get keyFields() {
        return vWB_AffSet_KeyFields
    }

    get searchProviderFields() {
        return vWB_AffSet_Fields
    }

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Affinity_Search_ByCannibalizationType',
                this.searchProviderFields,
                [])

            // findRequest.order = ['AFFINITYSET_ID'];

            SearchUtils.intersectFilter(findRequest, "WB_MODEL_CANNIBALIZATIONM_ID", [this.aCannibalizationTypeId])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

}

class AffinitySetSearchByCannibalizationTypeSearchProfile
    implements ISearchProfile {

    aSearchProvider: ISearchProvider = undefined

    profileId = "CannibalizationType"
    profileName = "Search by Cannibalization Type"
    renderOptions = {ui5ResourceId: "AffinitySetSearchByCannibalizationTypeProfile"}

    profileFilter = [
        {profileFilterName: 'Id', searchProviderFieldId: 'AFFINITYSET_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'AFFINITYSET_NAME', renderOptions: {}}
    ]

    profileDisplayFields = [
        'AFFINITYSET_ID', 'AFFINITYSET_NAME', 'CANNIBALIZATION_TYPE_NAME', 'CUSTOMER_LEVEL_ID', 'PRODUCT_LEVEL_ID'
    ]

    profileTreeIdDefault = "default"
    profileTrees: ITree[] = []
    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault = ""   //string;
    profileSorts: ISearchSort[] = [] //ISearchSort[];

    constructor(WB_MODEL_CANNIBALIZATIONM_ID: number) {
        this.aSearchProvider = new AffinitySetSearchByCannibalizationTypeSearchProvider(WB_MODEL_CANNIBALIZATIONM_ID)
    }

    get profileSearchProvider() {
        return this.aSearchProvider
    }

}


export class AffinitySetSearchByCannibalizationType
    implements ISearch {

    constructor(WB_MODEL_CANNIBALIZATIONM_ID: number, options?: any) {
        this.searchProfiles = [new AffinitySetSearchByCannibalizationTypeSearchProfile(WB_MODEL_CANNIBALIZATIONM_ID)]
    }

    searchName = "Find Affinity Sets"
    renderOptions = {ui5ResourceId: "AffinitySetSearchByCannibalizationType"}
    searchProfileIdDefault = "default"
    searchProfiles: ISearchProfile[] = []
    autoSearch = true


}
